import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { paymentMethodsApi } from "./api";

export const paymentMethodKeys = {
  all: ["payment-methods"] as const,
};

export function usePaymentMethods(enabled = true, includeInactive = false) {
  return useQuery({
    queryKey: [...paymentMethodKeys.all, { includeInactive }],
    queryFn: () => paymentMethodsApi.list(includeInactive),
    enabled,
    staleTime: 5 * 60_000, // payment methods rarely change
  });
}

export function useCreatePaymentMethod() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: paymentMethodsApi.create,
    onSuccess: () => client.invalidateQueries({ queryKey: paymentMethodKeys.all }),
  });
}

export function useUpdatePaymentMethod() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: Parameters<typeof paymentMethodsApi.update>[1] }) =>
      paymentMethodsApi.update(id, body),
    onSuccess: () => client.invalidateQueries({ queryKey: paymentMethodKeys.all }),
  });
}

export function useReorderPaymentMethods() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: paymentMethodsApi.reorder,
    onSuccess: (data) => {
      // El endpoint devuelve la lista completa ya reordenada: la escribimos
      // directo en la entrada de cache del admin (includeInactive: true)
      // para que las filas no parpadeen mientras se revalida.
      client.setQueryData([...paymentMethodKeys.all, { includeInactive: true }], data);
      // Invalida TODAS las entradas de "payment-methods" (admin y también
      // includeInactive: false de la pantalla de cobro) para que el nuevo
      // orden se refleje en ambas, no solo en el admin.
      client.invalidateQueries({ queryKey: paymentMethodKeys.all });
    },
  });
}
